export default __webpack_public_path__ + "media/images/45-arrow-22da159629cf9379851862c8ef9c660a.svg";